export const multiSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "40px",
    maxHeight: "40px",
    height: "40px",
    width: "100%",
    flexWrap: "nowrap",
    overflow: "hidden",
    borderRadius: "6px",
    border: state.isFocused ? "1px solid #80bdff" : "1px solid #cfd6e4",
    boxShadow: state.isFocused ? "0 0 0 1px #80bdff" : "none",
    "&:hover": { borderColor: "#80bdff" },
    cursor: "pointer",
  }),

  valueContainer: (base) => ({
    ...base,
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",          // ← X axis scroll for chips
    overflowY: "hidden",
    height: "36px",
    maxHeight: "36px",
    padding: "0 6px",
    alignItems: "center",
    // Show X scrollbar always
    scrollbarWidth: "thin",               // Firefox - thin visible bar
    scrollbarColor: "#cfd6e4 transparent", // Firefox - scrollbar color
  }),

  multiValue: (base) => ({
    ...base,
    flex: "0 0 auto",
    margin: "0 3px",
    maxWidth: "150px",
    minWidth: "0",
  }),

  multiValueLabel: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: "2px 6px",
  }),

  multiValueRemove: (base) => ({
    ...base,
    flexShrink: 0,
    padding: "0 4px",
    cursor: "pointer",
  }),

  input: (base) => ({
    ...base,
    flex: "0 0 auto",
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "40px",
    flexShrink: 0,
    alignSelf: "center",
  }),

  menu: (base) => ({
    ...base,
    width: "100%",
    zIndex: 9999,
  }),

  menuList: (base) => ({
    ...base,
    maxHeight: "200px",
    overflowY: "scroll",                  // ← always show Y scrollbar on right
    scrollbarWidth: "thin",               // Firefox
    scrollbarColor: "#a0aec0 transparent", // Firefox
  }),

  option: (base, state) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: state.isSelected
      ? "#80bdff"
      : state.isFocused
      ? "#f0faf9"
      : "white",
    color: state.isSelected ? "white" : "#374151",
    cursor: "pointer",
  }),
};
